var map = {
	"./CookiePolicyIT": [
		"TLPi",
		26
	],
	"./CookiePolicyIT.vue": [
		"TLPi",
		26
	],
	"./ExecutiveSummaryIT": [
		"QrUz",
		25
	],
	"./ExecutiveSummaryIT.vue": [
		"QrUz",
		25
	],
	"./PrivacyIT": [
		"77z6",
		24
	],
	"./PrivacyIT.vue": [
		"77z6",
		24
	],
	"./TermsAndConditionsIT": [
		"UnwQ",
		23
	],
	"./TermsAndConditionsIT.vue": [
		"UnwQ",
		23
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8Fp+";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views/service/lang lazy ^\.\/.*$
// module id = 8Fp+
// module chunks = 1